import React, {useEffect, useRef, useState} from "react"
import {Form} from "react-bootstrap"
import {Controller, useForm} from "react-hook-form";
import {useNavigate} from "react-router";
import ThemeButton from "../../../../components/common/theme-button/ThemeButton";
import {maxLength, PasswordValidation, Required} from "../../../../utils/patterns";
import {RoundedCheck} from "../../../../../assets/icons/defaultIcons";
import {notification} from "antd";
import PasswordInput from "../../../../components/common/password-field/PasswordInput";
import {UserAuthService} from "../../../../services/user-auth-api.service";
import Heading from "../../../../components/dashboard/heading-component/Heading";
import {useJournal} from "../../../../providers/JournalContext";

export default function ValidateJournalPassword({close, getListing, setGetListing}) {
    const[loader,setLoader] = useState(false);
    const { setJournalPasswordSetted ,journalPasswordSetted} = useJournal()

    const navigate = useNavigate()

    const {
        handleSubmit,
        reset,
        setValue,
        formState: {errors, isValid},
        control,
        watch,
        clearErrors
    } = useForm({
        mode: 'onChange',
    })

    const password = useRef({})
    password.current = watch('password', '')

    const onSubmit = async (data) => {
        setLoader(true)

        if(data){
            let payload = {
                password: data.password,
                confirmPassword: data.cpassword
            }
            const response = await UserAuthService.ResetJournalPassword(payload)

            if (response?.data?.data?.status){

                notification.success({
                    message: "Success",
                    description: response.data?.data?.message,
                    placement: "topRight",
                    icon: <RoundedCheck/>,
                    duration: 2,
                });
                setJournalPasswordSetted(true)
                setLoader(false)
                navigate('/journals/validate-password')
            }
            // else{
            //     notification.error({
            //         message: "Failed",
            //         description: response.data?.data?.message,
            //         placement: "topRight",
            //         icon: <CloseRoundedCheck/>,
            //         duration: 2,
            //     });
            //     setLoader(false)
            // }
        }

    }


    useEffect(()=>{
        if (journalPasswordSetted) {
            navigate('/journals/validate-password');
        }
    })


    return(
        <div className={'align-content-center h-100'}>
            <div className={'validate-journals'}>
                <Heading heading={'Reset Password'} back={true}/>
                <p>Set your password to use add your journals</p>
                <Form onSubmit={handleSubmit(onSubmit)}>
                    <div className={'dfields'}>
                        <Controller
                            name="password"
                            defaultValue={''}
                            control={control}
                            rules={{required: Required, pattern:PasswordValidation, maxLength: maxLength(100)}}
                            render={({field: {name, ...field}}) => (
                                <PasswordInput
                                    placeholder={'Enter new password here'}
                                    label={'New Password'}
                                    field={field}
                                    errors={errors.password}
                                    className={'required'}
                                />
                            )}
                        />
                    </div>
                    <div className={'dfields'}>
                        <Controller
                            name="cpassword"
                            defaultValue={''}
                            control={control}
                            rules={{
                                required: Required,
                                validate: (value) => value == password.current || 'The password does not match',
                            }}
                            render={({field: {name, ...field}}) => (
                                <PasswordInput
                                    placeholder={'Re-enter new password here'}
                                    label={'Re-enter New Password'}
                                    field={field}
                                    errors={errors.cpassword}
                                    className={'required'}
                                />
                            )}
                        />
                    </div>
                    <div className={'mt-30'}>
                        <ThemeButton
                            text={'Update'}
                            type={'submit'}
                            className={'btn-light-lg'}
                            loader={loader}
                        />
                    </div>
                </Form>
            </div>
        </div>
    )
}